import React from 'react';
import {
  AccountBalance as BankIcon,
  Park as VenueIcon,
  CurrencyExchange as ExchangeIcon,
  AdminPanelSettings as AdminIcon,
  Dashboard as DashboardIcon,
  AccountBalanceWallet as WalletIcon,
  SwapHoriz as TransactionIcon,
  Assignment as OrdersIcon,
  AccountBalance as AssetsIcon,
  LocalActivity as TicketMarketIcon,
  ConfirmationNumber as IssueIcon,
  VerifiedUser as VerifyIcon,
  Description as ContractIcon,
  ViewList as BlockchainIcon,
  Settings as SettingsIcon,
  Hub as HubIcon,
  AccountTree as SubAccountIcon,
  Gavel as RegulatorIcon,
  Person as PersonIcon,
  ShowChart as MarketMakerIcon,
  Business as BusinessIcon,
  Store as StoreIcon,
  PlaylistAddCheck as ReviewIcon,
  Block as BlockIcon,
  AttachMoney as FeeIcon,
  Token as MintIcon,
  DeleteForever as DestroyIcon,
  Gavel as AuctionIcon,
  Payment as PaymentIcon,
  AccountBalanceWallet as FinanceIcon,
  Assessment as CreditIcon,
  RateReview as LoanIcon,
  MoneyOff as RepayIcon,
  LocalShipping as DeliveryIcon,
  Receipt as SettlementIcon,
  TrendingUp as SecondaryIcon,
} from '@mui/icons-material';

export interface PortalMenuItem {
  text: string;
  icon: React.ReactElement;
  path: string;
}

export interface PortalConfig {
  id: string;
  name: string;
  subtitle: string;
  icon: React.ReactElement;
  color: string;
  gradient: string;
  basePath: string;
  defaultChild: string;
  menuItems: PortalMenuItem[];
}

export const portals: PortalConfig[] = [
  {
    id: 'bank',
    name: '银行业务',
    subtitle: '客户、入金、信贷与还款管理',
    icon: React.createElement(BankIcon, { sx: { fontSize: 48 } }),
    color: '#1565c0',
    gradient: 'linear-gradient(135deg, #1565c0 0%, #42a5f5 100%)',
    basePath: '/bank',
    defaultChild: 'dashboard',
    menuItems: [
      { text: '工作台', icon: React.createElement(DashboardIcon), path: 'dashboard' },
      { text: '做市商客户', icon: React.createElement(BusinessIcon), path: 'market-makers' },
      { text: '入金登记', icon: React.createElement(FinanceIcon), path: 'deposits' },
      { text: '信用评估', icon: React.createElement(CreditIcon), path: 'credit' },
      { text: '贷款审核', icon: React.createElement(LoanIcon), path: 'loan' },
      { text: '还款管理', icon: React.createElement(RepayIcon), path: 'repayment' },
    ],
  },
  {
    id: 'venue',
    name: '景区管理',
    subtitle: '门票发行、核销与管理',
    icon: React.createElement(VenueIcon, { sx: { fontSize: 48 } }),
    color: '#2e7d32',
    gradient: 'linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)',
    basePath: '/scenic',
    defaultChild: 'dashboard',
    menuItems: [
      { text: '工作台', icon: React.createElement(SubAccountIcon), path: 'dashboard' },
      { text: '门票发行', icon: React.createElement(IssueIcon), path: 'issue-ticket' },
      { text: '门票核销', icon: React.createElement(VerifyIcon), path: 'verify-ticket' },
      { text: '铸造记录', icon: React.createElement(MintIcon), path: 'ticket-minting' },
      { text: '库存管理', icon: React.createElement(DestroyIcon), path: 'inventory' },
      { text: '退票管理', icon: React.createElement(ReviewIcon), path: 'refund-management' },
      { text: '节点监控', icon: React.createElement(DashboardIcon), path: 'node-dashboard' },
      { text: '区块链状态', icon: React.createElement(BlockchainIcon), path: 'blockchain' },
    ],
  },
  {
    id: 'exchange',
    name: '大宗合约撮合',
    subtitle: '机构门票合约流程验证',
    icon: React.createElement(ExchangeIcon, { sx: { fontSize: 48 } }),
    color: '#e65100',
    gradient: 'linear-gradient(135deg, #e65100 0%, #ff9800 100%)',
    basePath: '/institutional-market',
    defaultChild: 'portal',
    menuItems: [
      { text: '合约撮合首页', icon: React.createElement(DashboardIcon), path: 'portal' },
      { text: '流转规则', icon: React.createElement(SecondaryIcon), path: 'secondary-market' },
      { text: '竞拍合约', icon: React.createElement(AuctionIcon), path: 'auction' },
      { text: '市场总览', icon: React.createElement(StoreIcon), path: 'market' },
      { text: '资产管理', icon: React.createElement(AssetsIcon), path: 'account' },
    ],
  },
  {
    id: 'market-maker',
    name: '合约运营端',
    subtitle: '门票合约流程与风控验证',
    icon: React.createElement(MarketMakerIcon, { sx: { fontSize: 48 } }),
    color: '#00695c',
    gradient: 'linear-gradient(135deg, #00695c 0%, #26a69a 100%)',
    basePath: '/market-maker',
    defaultChild: 'dashboard',
    menuItems: [
      { text: '工作台', icon: React.createElement(DashboardIcon), path: 'dashboard' },
      { text: '散票挂售', icon: React.createElement(TicketMarketIcon), path: 'retail-listings' },
      { text: '竞拍中心', icon: React.createElement(AuctionIcon), path: 'auction' },
      { text: '尾款支付', icon: React.createElement(PaymentIcon), path: 'payment' },
      { text: '融资管理', icon: React.createElement(FinanceIcon), path: 'finance' },
      { text: '节点监控', icon: React.createElement(DashboardIcon), path: 'node-dashboard' },
      { text: '区块链状态', icon: React.createElement(BlockchainIcon), path: 'blockchain' },
      { text: '消息中心', icon: React.createElement(OrdersIcon), path: 'messages' },
    ],
  },
  {
    id: 'admin',
    name: '管理后台',
    subtitle: '系统管理与合约运维',
    icon: React.createElement(AdminIcon, { sx: { fontSize: 48 } }),
    color: '#c62828',
    gradient: 'linear-gradient(135deg, #c62828cc 0%, #ef5350cc 100%)',
    basePath: '/institutional-market-admin',
    defaultChild: 'admin-dashboard',
    menuItems: [
      { text: '综合仪表盘', icon: React.createElement(DashboardIcon), path: 'admin-dashboard' },
      { text: '企业认证', icon: React.createElement(BusinessIcon), path: 'enterprise-cert' },
      { text: '景区入驻', icon: React.createElement(StoreIcon), path: 'venue-admission' },
      { text: '发行审核', icon: React.createElement(ReviewIcon), path: 'issuance-review' },
      { text: '合约操作管理', icon: React.createElement(BlockIcon), path: 'trade-control' },
      { text: '费用配置', icon: React.createElement(FeeIcon), path: 'fee-config' },
      { text: '合约执行管理', icon: React.createElement(ExchangeIcon), path: 'trading-ops' },
      { text: '财务管理', icon: React.createElement(FinanceIcon), path: 'finance' },
      { text: '风控合规', icon: React.createElement(RegulatorIcon), path: 'risk-compliance' },
      { text: '数据报表', icon: React.createElement(DashboardIcon), path: 'data-reports' },
      { text: '区块浏览器', icon: React.createElement(BlockchainIcon), path: 'blockchain' },
      { text: '节点监控', icon: React.createElement(DashboardIcon), path: 'node-dashboard' },
      { text: '消息中心', icon: React.createElement(OrdersIcon), path: 'messages' },
    ],
  },
  {
    id: 'regulator',
    name: '监管端',
    subtitle: '智能合约执行与审计规则验证',
    icon: React.createElement(RegulatorIcon, { sx: { fontSize: 48 } }),
    color: '#b71c1c',
    gradient: 'linear-gradient(135deg, #b71c1ccc 0%, #e53935cc 100%)',
    basePath: '/supervise',
    defaultChild: 'dashboard',
    menuItems: [
      { text: '监管仪表盘', icon: React.createElement(DashboardIcon), path: 'dashboard' },
      { text: '合约执行监控', icon: React.createElement(BlockchainIcon), path: 'blockchain' },
      { text: '交割监控', icon: React.createElement(DeliveryIcon), path: 'delivery-monitor' },
      { text: '结算监控', icon: React.createElement(SettlementIcon), path: 'settlement-monitor' },
      { text: '智能监管', icon: React.createElement(RegulatorIcon), path: 'agent' },
    ],
  },
  {
    id: 'retail',
    name: '消费者',
    subtitle: '门票申领与权益资产管理',
    icon: React.createElement(PersonIcon, { sx: { fontSize: 48 } }),
    color: '#6a1b9a',
    gradient: 'linear-gradient(135deg, #6a1b9a 0%, #ab47bc 100%)',
    basePath: '/consumer-retail',
    defaultChild: 'portal',
    menuItems: [
      { text: '票务首页', icon: React.createElement(DashboardIcon), path: 'portal' },
      { text: '权益市场', icon: React.createElement(TicketMarketIcon), path: 'market' },
      { text: '我的订单', icon: React.createElement(OrdersIcon), path: 'orders' },
      { text: '我的资产', icon: React.createElement(AssetsIcon), path: 'account' },
    ],
  },
  {
    id: 'retail-admin',
    name: '消费者管理后台',
    subtitle: '订单管理、客服与运营分析',
    icon: React.createElement(AdminIcon, { sx: { fontSize: 48 } }),
    color: '#7b1fa2',
    gradient: 'linear-gradient(135deg, #7b1fa2 0%, #ce93d8 100%)',
    basePath: '/consumer-retail-admin',
    defaultChild: 'dashboard',
    menuItems: [
      { text: '仪表盘', icon: React.createElement(DashboardIcon), path: 'dashboard' },
      { text: '内容管理', icon: React.createElement(ContractIcon), path: 'content' },
      { text: '挂单管理', icon: React.createElement(TicketMarketIcon), path: 'listings' },
      { text: '订单管理', icon: React.createElement(OrdersIcon), path: 'orders' },
      { text: '消息中心', icon: React.createElement(DashboardIcon), path: 'messages' },
    ],
  },
  {
    id: 'platform',
    name: '平台管理系统',
    subtitle: '账户生成、角色授权与网络监管',
    icon: React.createElement(HubIcon, { sx: { fontSize: 48 } }),
    color: '#283593',
    gradient: 'linear-gradient(135deg, #283593 0%, #5c6bc0 100%)',
    basePath: '/total-admin',
    defaultChild: 'dashboard',
    menuItems: [
      { text: '平台总览', icon: React.createElement(DashboardIcon), path: 'dashboard' },
      { text: '账户与权限', icon: React.createElement(WalletIcon), path: 'account-management' },
      { text: '银行与 Fiat', icon: React.createElement(BankIcon), path: 'bank-management' },
      { text: '运营分析', icon: React.createElement(DashboardIcon), path: 'analytics' },
      { text: '监控告警', icon: React.createElement(BlockIcon), path: 'monitoring-alerts' },
      { text: '资源管理', icon: React.createElement(BlockchainIcon), path: 'auxiliary' },
      { text: '区块链状态', icon: React.createElement(BlockchainIcon), path: 'blockchain' },
      { text: '合约管理', icon: React.createElement(ContractIcon), path: 'contracts' },
      { text: '资产迁移', icon: React.createElement(TransactionIcon), path: 'migration' },
      { text: '系统设置', icon: React.createElement(SettingsIcon), path: 'settings' },
    ],
  },
];

export function getPortalById(id: string): PortalConfig | undefined {
  return portals.find((p) => p.id === id);
}
